import { gql } from "@apollo/client";

export default gql`
    query couponUsers($code: String!) {
        subscription_coupon(where: { code: { _eq: $code } }, limit: 1) {
            code
            user_type
            list_of_users
        }
    }
`;
